import { put, takeLatest } from 'redux-saga/effects';

import { api, makeRequest } from 'shared/sdk';

const actionPrefix = 'CountryField/';

const FETCH_COUNTRIES = `${actionPrefix}FETCH_COUNTRIES`;
const SUCCESS_FETCH_COUNTRIES = `${actionPrefix}SUCCESS_FETCH_COUNTRIES`;

export const fetchCountries = () => ({ type: FETCH_COUNTRIES });

const successFetchCountries = ({ data: { results } }) => ({
  type: SUCCESS_FETCH_COUNTRIES,
  payload: { results }
});

const initialState = {
  options: []
};

export const countryFieldReducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case SUCCESS_FETCH_COUNTRIES:
      newState['options'] = action.payload.results.map(({ id, name }) => ({
        value: id,
        label: name
      }));
      break;

    default:
      return newState;
  }

  return newState;
};

function* fetchCountriesWorker(action) {
  const response = yield makeRequest(api.countriesList, {
    requestData: {
      params: {
        limit: 500,
        offset: 0,
        ordering: 1
      }
    }
  });

  if (response.success) {
    yield put(successFetchCountries(response));
  }
}

export function* countryFieldSaga() {
  yield takeLatest(FETCH_COUNTRIES, fetchCountriesWorker);
}
